// Cache Storage names and matching rules shared by the page and the service worker.

export const THUMBNAIL_CACHE = "vantero-menu-thumbs-v1"
export const DISPLAY_CACHE = "vantero-menu-display-v1"
export const DISPLAY_CACHE_MAX_BYTES = 200 * 1024 * 1024

// Content-addressed thumbnail keys from MEDIA_IMAGE_VARIANTS.md.
const THUMBNAIL_PATH = /\/variants\/[^/]+\/thumbnail-\d+\.webp$/

export function isThumbnailUrl(href) {
  try {
    return THUMBNAIL_PATH.test(new URL(href).pathname)
  } catch {
    return false
  }
}

// Menu photos are cross-origin S3 media keys; nothing else is intercepted.
export function isMenuImageRequest(request, url, appOrigin) {
  return request.destination === "image" && url.origin !== appOrigin && url.pathname.includes("/media/")
}
